import TauronDocumentDetails from './TauronDocumentDetails';

export default TauronDocumentDetails;
